<template>

  <div style="float:right">
    <div v-if="menu.length < 1 && styleType === 'mcd'" style="color: #222523;margin-top:0;float:left;margin-left:-83vw">
      <!-- <img src="@/assets/JNBYLogo.png" style="width:70%" alt="logo"> -->
      <div style="display:flex;height:80px">
        <div class="mcd-title">McDonald's</div>
      </div>
    </div>
    <div class="header">
      <div class="container-wrap">
        <!--        <div style="color: #ffffff;margin-right: 60px;">-->
        <!--          Chinese &nbsp;<a-switch v-model="defaultLan" @change="onChange"/>&nbsp;English-->
        <!--        </div>-->

        <!-- <div style="color: #fff;padding-right:30px;">
          ATOM
          <span style="border:1px solid gray;border-radius: 30px;padding-bottom:3px;"><a-switch :checked="styleType" @click="onChangeStyle" /></span>
          MCD
        </div> -->
        <a-avatar style="margin-top: -2%" class="header-avatar">

          <span style="color: #fff">
            {{ username.toString().substring(0, 2) }}
          </span>
        </a-avatar>
        <a-dropdown style="margin-left:10px;">
          <a style="color: #ffffff" class="ant-dropdown-link" @click="e => e.preventDefault()">
            {{ username }}
            <a-icon type="down" />
          </a>
          <a-icon slot="icon" type="down" />
          <a-menu slot="overlay" :style="{ marginLeft: '-30px', marginTop: '-20px' }">
            <!-- <a-menu-item key="0" @click="onChangeStyle">
              <a-icon type="skin" style="font-size:16px;margin-right:4px;"/>
              {{ styleName }}风格
            </a-menu-item> -->

            <!-- <a-sub-menu key="test">
              <span slot="title">
                <a-icon type="skin" style="font-size:16px;margin-right:4px;"/>
                {{ styleName }}
              </span>
              <a-menu-item @click="changeTypeA('atom')" :class="{selectStyle: styleType==='atom'}">
                {{ $t('message.header.style2') }}
              </a-menu-item>
              <a-menu-item @click="changeTypeA('mcd')" :class="{selectStyle: styleType==='mcd'}">
                {{ $t('message.header.style1') }}
              </a-menu-item>
              <a-menu-item @click="changeTypeA('yoplait')" :class="{selectStyle: styleType==='yoplait'}">
                {{ $t('message.header.style3') }}
              </a-menu-item>
            </a-sub-menu> -->
            <a-menu-item key="2" v-if="isMicrosoft" @click="updatePassword">
              <a-icon type="tool" style="font-size:16px;margin-right:4px;" />
              {{ $t('message.header.changePassword') }}
            </a-menu-item>
            <a-menu-item key="3" @click="updateTimezone">
              <a-icon type="tool" style="font-size:16px;margin-right:4px;" />
              {{ getTimezone }}
            </a-menu-item>
            <a-menu-item key="4" @click="updateSubscription">
              <a-icon type="tool" style="font-size:16px;margin-right:4px;" />
              {{ subscriptionName }}
            </a-menu-item>
            <a-menu-item key="1" @click="logonOut">
              <div>
                <div style="float: left;padding-right: 5px;margin-top: -2px">
                  <svg style="margin-top: 5px" t="1612498750741" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="586" width="16" height="16">
                    <path
                      d="M814.872883 1023.847887H151.661433a106.478903 106.478903 0 0 1-112.056369-101.408478V101.537774a106.985945 106.985945 0 0 1 112.056369-101.408478h663.21145a106.985945 106.985945 0 0 1 112.056369 101.408478v177.464838a38.028179 38.028179 0 0 1-76.056359 0V101.537774c0-11.661975-15.211272-24.338035-36.00001-24.338034H151.661433c-21.295781 0-36.00001 12.67606-36.00001 24.338034v822.422762c0 11.154933 14.704229 23.830992 36.00001 23.830992h663.21145c20.788738 0 36.00001-12.67606 36.00001-23.830992v-176.957795a38.028179 38.028179 0 0 1 76.056359 0v176.957795a106.985945 106.985945 0 0 1-112.056369 99.887351z"
                      fill="#20002A" p-id="587">
                    </path>
                    <path
                      d="M945.68982 557.875928H367.15445a38.028179 38.028179 0 1 1 0-76.056359h501.971969l-87.718334-113.070453a38.028179 38.028179 0 0 1 60.845087-46.140858l133.859192 175.94371a38.028179 38.028179 0 0 1-30.422544 60.845087z"
                      fill="#20002A" p-id="588">
                    </path>
                    <path
                      d="M809.295416 719.622451a38.028179 38.028179 0 0 1-28.901416-60.338044l136.394404-162.760608a38.028179 38.028179 0 1 1 57.802833 50.704239l-136.394404 160.225396a37.014095 37.014095 0 0 1-28.901417 12.169017z"
                      fill="#20002A" p-id="589">
                    </path>
                  </svg>
                </div>
                {{ $t('message.header.signOut') }}
              </div>
            </a-menu-item>
            <a-sub-menu key="language">
              <span slot="title">
                <a-icon type="global" style="font-size:16px;margin-right:4px;" />
                {{ $t('message.header.language') }}
              </span>
              <a-menu-item @click="langChange('zh')" :class="{ selectStyle: $i18n.locale.startsWith('zh') }">
                {{ $t('message.header.chinese') }}
              </a-menu-item>
              <a-menu-item @click="langChange('en')" :class="{ selectStyle: $i18n.locale.startsWith('en') }">
                {{ $t('message.header.english') }}
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <a-modal :title="$t('message.loginPage.changePassword')" :visible="visible" :maskClosable="false"
      :confirm-loading="confirmLoading" @ok="handleOk" @cancel="visible = false">
      <a-form-model :model="userInfo" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }" :rules="updateUserRules"
        ref="updateUser">
        <!-- <a-form-model-item :label="$t('message.loginPage.username')">
          <a-input :size="$globalSize" v-model="username" read-only></a-input>
        </a-form-model-item> -->
        <a-form-model-item :label="$t('message.loginPage.oldPassword')" prop="curPwd">
          <a-input-password :placeholder="$t('message.loginPage.oldPassword')" v-model="userInfo.curPwd" />
        </a-form-model-item>
        <a-form-model-item :label="$t('message.loginPage.newPassword')" prop="newPwd">
          <a-input-password :placeholder="$t('message.loginPage.newPassword')" v-model="userInfo.newPwd" />
        </a-form-model-item>
        <a-form-model-item :label="$t('message.loginPage.confirmPassword')" prop="repPwd">
          <a-input-password :placeholder="$t('message.loginPage.confirmPassword')" v-model="userInfo.repPwd" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="$t('message.header.changeTimezone')" :visible="timeVisible" :maskClosable="false"
      @cancel="timeVisible = false">
      <template slot="footer">

        <a-button :size="$globalSize" @click="timeVisible = false">
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <my-button :size="$globalSize" type="primary" @click="changeTimezone">
          {{ $t('message.commonUsage.save') }}
        </my-button>
      </template>
      <a-form-model :model="timezoneForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }"
        :rules="updateTimezoneRules" ref="updateTimezone">
        <a-form-model-item :label="$t('message.strategyStore.timezone')">
          <a-select v-model="timezoneForm.time_zone" :size="$globalSize">
            <a-select-option v-for="timezone in timezoneList" :key="timezone.tz" :value="timezone.tz">
              {{ `${timezone.city}(${timezone.offset})` }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>


    <a-modal :title="$t('message.header.subscriptionList')" :visible="subscriptionVisible" :maskClosable="false"
      @cancel="subscriptionVisible = false">
      <template slot="footer">
        <a-button :size="$globalSize" @click="subscriptionVisible = false">
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <my-button :size="$globalSize" type="primary" @click="changeSubscription">
          {{ $t('message.commonUsage.save') }}
        </my-button>
      </template>
      <a-list :data-source="subscriptionList" item-layout="horizontal" :loading="subscriptionLoading">
        <a-list-item slot="renderItem" slot-scope="item" :style="{
          'background-color': subscriptionID === item.subscription_id ? 'var(--main-color)' : 'transparent',
          'color': subscriptionID === item.subscription_id ? '#fff' : 'black',
          'border': '1px solid #d9d9d9',
          'padding': '8px',
          'margin-bottom': '8px',
          'cursor': 'pointer'
        }" @click="subscriptionID = item.subscription_id">
          {{ item.subscription_name }}
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import userListService from "@/interface/pages/Authority/UserAuthority/userList";
import loginService from "@/interface/pages/Login/login"
import { mapMutations } from 'vuex'
import Utils from "@/utils";
import MyButton from "@/components/MyButton/index";
import { userTypeConstant } from "../utils/constant";
import { timeZoneConstant } from "@/utils/constant";
export default {
  name: 'Header',
  components: {
    MyButton
  },
  data() {
    //强密码验证 不少于八位，且包含数字，大小写字母和特殊字符
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        callback('');
        return
      }

      if (value.length < 8) {
        callback(this.$t('message.loginPage.passwordCharacters'));
      } else {
        var password = value.toUpperCase();
        var newpassword = value;
        // 数字,特殊字符,大小写字母的匹配
        var boolean_num = false;
        var boolean_A = false;
        var boolean_a = false;
        var boolean_specialchar = false;
        for (var i = 0; i < newpassword.length; i++) {
          if (boolean_A == true && boolean_a == true && boolean_num == true
            && boolean_specialchar == true)
            break;
          if (newpassword[i].charCodeAt() >= 65
            && newpassword[i].charCodeAt() <= 90) {
            boolean_A = true;
            continue;
          }
          if (newpassword[i].charCodeAt() >= 48
            && newpassword[i].charCodeAt() <= 57) {
            boolean_num = true;
            continue;
          }
          if (newpassword[i].charCodeAt() >= 97
            && newpassword[i].charCodeAt() < 122) {
            boolean_a = true;
            continue;
          }
          if ((newpassword[i].charCodeAt() >= 33 && newpassword[i].charCodeAt() <= 47)
            || (newpassword[i].charCodeAt() >= 58 && newpassword[i]
              .charCodeAt() <= 64)
            || (newpassword[i].charCodeAt() >= 91
              && newpassword[i].charCodeAt() && newpassword[i]
                .charCodeAt() <= 96)
            || (newpassword[i].charCodeAt() >= 123 && newpassword[i]
              .charCodeAt() <= 127)) {
            boolean_specialchar = true;
            continue;
          }
        }
        if (boolean_A == false || boolean_a == false || boolean_num == false
          || boolean_specialchar == false) {
          callback(new Error(this.$t('message.loginPage.passwordFormat')));
        } else {
          callback();
        }
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('message.loginPage.passwordFormatError')));
      } else if (value !== this.userInfo.newPwd) {
        callback(new Error(this.$t('message.loginPage.passwordChangeFailedMsg2')));
      } else {
        callback();
      }
    };
    return {
      timeVisible: false,
      timezoneList: timeZoneConstant.getTimeZoneList(),
      timezoneForm: {
        time_zone: localStorage.getItem('time_zone'),

      },
      username: '',
      userType: userTypeConstant.MICROSOFT,
      brandOption: [],
      brandSelected: '',
      menu: JSON.parse(localStorage.getItem('menu')),
      confirmLoading: false,
      visible: false,
      userInfo: {
        curPwd: '',
        newPwd: '',
        repPwd: '',
      },
      updateUserRules: {
        curPwd: [{ required: true, message: () => this.$t('message.loginPage.oldPasswordTip'), trigger: 'blur' }],
        newPwd: [{ required: true, message: () => this.$t('message.loginPage.newPasswordTip'), trigger: 'blur' },
        { validator: checkPwd, trigger: 'change' }],
        repPwd: [{ required: true, message: () => this.$t('message.loginPage.confirmPasswordTip'), trigger: 'blur' },
        { validator: validatePass, trigger: 'change' }]
      },
      updateTimezoneRules: {
        time_zone: [{
          required: true,
          message: () => this.$t('message.strategyStore.selectedTimezone'),
          trigger: 'change'
        }],

      },
      styleType: false,
      styleName: this.$t('message.header.style'),
      defaultLan: localStorage.getItem('i18n') === 'en' ? true : false,
      subscriptionName: '',
      subscriptionID: '',
      subscriptionVisible: false,
      subscriptionList: [],
      subscriptionLoading: false
    }
  },
  mounted() {
    this.username = localStorage.getItem("userName");
    this.userType = localStorage.getItem("userType");
    this.subscriptionName = localStorage.getItem("subscriptionName");
    this.subscriptionID = localStorage.getItem("subscriptionID");
    this.styleType = this.$store.state.style
    this.styleName = this.$t('message.header.style2')
    this.langChange(localStorage.getItem('i18n') || 'en')
  },
  computed: {
    getTimezone() {
      return timeZoneConstant.getTimeZoneByValue(this.timezoneForm.time_zone) ? timeZoneConstant.getTimeZoneByValue(this.timezoneForm.time_zone).offset : 'GMT'
    },
    isMicrosoft() {
      return this.userType !== userTypeConstant.MICROSOFT
    }
  },
  methods: {
    updateSubscription() {
      this.getSubscriptionList()
      this.subscriptionID = localStorage.getItem("subscriptionID");
      this.subscriptionVisible = true
    },
    async getSubscriptionList() {
      try {
        this.subscriptionLoading = true
        const { data: res } = await userListService.getSubscriptionList(this, { params: { email: localStorage.getItem("email") } })
        if (res.code === '200') {
          this.subscriptionList = res.data
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.subscriptionLoading = false
      }
    },
    changeSubscription() {
      return new Promise((resolve, reject) => {
        const data = {
          subscription_id: this.subscriptionID,
          email: localStorage.getItem("email")
        }
        userListService.updateSubscription(this, { data })
          .then(async (response) => {
            let res = response.data;
            if (res.code == 200) {
              this.initInfo(res.data)

              try {
                const { data: result } = await loginService
                  .getUserMenu(this, {
                    params: {
                      userId: localStorage.getItem("userId"),
                    },
                  })
                if (result.code == 200) {
                  localStorage.setItem("menu", JSON.stringify(result.data));
                  this.subscriptionVisible = false
                  this.$message.success(result.message);
                  resolve()
                  location.reload()
                }
              } catch (err) {
                reject()
                console.log(err)
              }
            } else {
              reject()
              this.$message.error(res.message);
            }
          })
          .catch((error) => {
            reject()
          })
      })
    },
    initInfo(data) {
      localStorage.setItem("userName", data.user_name);
      localStorage.setItem("userId", data.user_id);
      localStorage.setItem("token", data.token);
      localStorage.setItem("time_zone", data.time_zone);
      localStorage.setItem("subscriptionName", data.subscription_name);
      localStorage.setItem("subscriptionID", data.subscription_id);
      localStorage.setItem("userType", data.type); // Microsoft or Atom
      localStorage.setItem("email", data.email);

    },
    langChange(val) {
      this.$i18n.locale = val
      localStorage.setItem('i18n', val)
      this.styleType = this.$store.state.style
      this.styleName = this.$t('message.header.style2')

      this.$emit('languageChange')
      this.$bus.$emit('onLanguageChange')

      // this.changeLanguage({ lang: val })
    },
    async changeLanguage(params) {
      // /api/userManagement/changeLanguage?lang=en_US
      await loginService.changeLanguage(this, { params }).then()
    },
    changeTypeA(type) {
      this.changeStyle(type)
    },
    ...mapMutations(['exchangeStyle']),
    onChangeStyle() {
      // let type = this.styleType === 'mcd'? 'atom' : 'mcd'
      // this.changeStyle(type)
    },
    changeTimezone() {
      return new Promise((resolve, reject) => {
        this.$refs.updateTimezone.validate(valid => {
          if (!valid) {
            reject()
            return
          }
          const data = {
            time_zone: this.timezoneForm.time_zone
          }
          userListService.updTimezone(this, { data })
            .then((response) => {
              let res = response.data;
              if (res.code == 200) {
                this.timeVisible = false
                this.$message.success(res.message);
                localStorage.setItem('time_zone', this.timezoneForm.time_zone)
                resolve()
                location.reload()
              } else {
                reject()
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              reject()
              console.log("添加失败！");
            })
        })
      })
    },
    changeStyle(style) {
      let param = { style }
      loginService.updUserStyle(this, { data: param }).then(
        function (resp) {
          var res = resp.data;
          if (res.code == "200") {
            this.$message.success(res.message);
            // this.exchangeStyle(style)
            // styleChange(style)
            let path = this.$route.path
            if (path === '/dataAnalysis/userAnalysis') {
              location.reload();
            } else {
              this.$router.push("/dataAnalysis/userAnalysis");
              setTimeout(() => {
                location.reload();
              }, 100)
            }
          } else {
            this.$message.error(res.message, 3);
          }
        }.bind(this)
      ).catch(reason => {
        console.log(reason)
      })
    },
    handleOk() {
      this.$refs.updateUser.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const data = {
            newPassword: Utils.encrypt(this.userInfo.newPwd),
            oldPassword: Utils.encrypt(this.userInfo.curPwd),
          }
          userListService.updPwd(this, { data })
            .then((response) => {
              let res = response.data;
              if (res.code == 200) {
                this.visible = false
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              console.log("添加失败！");
            }).finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    updateTimezone() {
      this.timeVisible = true
    },
    updatePassword() {
      this.visible = true
      this.userInfo = {}
      this.confirmLoading = false
    },
    logonOut(item) {
      this.$message.success(this.$t('message.loginPage.logOut'));
      localStorage.clear();
      localStorage.setItem('isLogout', 'true');
      setTimeout(() => {
        this.$router.push({
          path: "/login"
        });
      }, 800)
    },
  }
};
</script>
<style lang="less" scoped>
.header {
  float: right;
  margin-right: 70px;
}

.container-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  float: right;
  margin-right: 100px;
}

.brand-container {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tagItem,
.tagItems {
  height: 50px;
  width: 90px;
  margin-right: 6px;
  // border-right: 1px solid rgba(232,232,232,.2)

}

.tagItem {
  background: #908D7C;
}

.note {
  width: 170px;
}

.logo001 {
  width: 180px
}

.logo002 {
  width: 190px;
}

.logo004 {
  width: 100px;
}

.logo005 {
  width: 130px;
}

.logo006 {
  width: 180px;
}

.logo007,
.logo008 {
  width: 76px;
}

.brand-menu ::v-deep .ant-dropdown-menu-item:hover {
  background: rgb(124, 122, 107) !important;
}

.mcd-title {
  font-family: 'PingFangSC-Regular';
  height: 80px;
  line-height: 80px;
  font-size: 26px;
  color: #FFBC0D;
  float: left;
}

.selectStyle {
  color: var(--main-color);
  background-color: #F0F0F0;
}
</style>
